module.exports = __webpack_public_path__ + "img/search.fd061dda.svg";